export var INITIALIZE_FORM = 'AOR/INITIALIZE_FORM';
export var initializeForm = function initializeForm(initialValues) {
  return {
    type: INITIALIZE_FORM,
    payload: initialValues
  };
};